var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8 26V28.3H2V26C2.02043 22.8026 3.11189 19.7043 5.1 17.2C6.42995 15.4719 8.14261 14.0758 10.1033 13.1214C12.0641 12.1671 14.2194 11.6805 16.4 11.7C18.6032 11.6922 20.7784 12.1935 22.7558 13.1649C24.7333 14.1363 26.4596 15.5515 27.8 17.3C29.7182 19.7973 30.7712 22.8512 30.8 26Z",
    fill: "url(#paint0_linear_20_255)",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4001 13.5C29.4008 14.2082 29.2596 14.9093 28.9848 15.562C28.7099 16.2146 28.3071 16.8056 27.8001 17.3C26.4597 15.5515 24.7334 14.1363 22.7559 13.1649C20.7784 12.1935 18.6033 11.6922 16.4001 11.7C14.2195 11.6805 12.0642 12.1671 10.1034 13.1214C8.1427 14.0757 6.43004 15.4719 5.10008 17.2C4.16248 16.1929 3.62852 14.8757 3.60008 13.5C3.58679 12.8088 3.71147 12.1218 3.96683 11.4793C4.2222 10.8368 4.60312 10.2518 5.08732 9.75825C5.57151 9.26474 6.14926 8.87273 6.78676 8.60517C7.42426 8.33762 8.10871 8.19989 8.80008 8.20002C9.6792 8.21823 10.5393 8.45908 11.3001 8.90003C11.3767 7.57355 11.9582 6.32669 12.9253 5.41547C13.8923 4.50426 15.1714 3.99779 16.5001 4.00001C17.8218 4.02119 19.0879 4.53549 20.0499 5.44202C21.0119 6.34856 21.6005 7.58192 21.7001 8.90003C22.4608 8.45908 23.321 8.21823 24.2001 8.20002C24.8915 8.19989 25.5759 8.33762 26.2134 8.60517C26.8509 8.87273 27.4287 9.26474 27.9128 9.75825C28.397 10.2518 28.778 10.8368 29.0333 11.4793C29.2887 12.1218 29.4134 12.8088 29.4001 13.5Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8999 19.7L11.1999 18.4",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2998 21.9L17.5998 23.3",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 19.1L21.7 18.4",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20_255",
    x1: 2.10015,
    y1: 14.2813,
    x2: 17.74,
    y2: 37.2177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26702"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaco);
export default __webpack_public_path__ + "static/media/taco.98e5fdafde17f5571d76ad59945e6492.svg";
export { ForwardRef as ReactComponent };